import { Directive, EventEmitter, Output, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[scrollToTop]'
})
export class ScrollToTopDirective {
    scrollableDiv: HTMLElement;
    scrollToTopButton: HTMLElement;

    @Output() public hasScrolled = new EventEmitter<boolean>();

    constructor() {
        this.scrollableDiv = document.querySelector('#bodyContent');
        this.scrollToTopButton = document.querySelector('button.scroll-to-top');
        
        if (this.scrollableDiv)
        {
            this.scrollableDiv.addEventListener("scroll", (event) => {
                var htmlElement = event.currentTarget as HTMLElement;
                this.hasScrolled.emit(htmlElement.scrollTop > 0);
            });

            if (this.scrollToTopButton) {
                this.scrollToTopButton.addEventListener('click', () => {
                    this.scrollableDiv.scrollTo(0, 0);
                });
            }
        }
    }
}